import { SVGProps } from 'react';

const SparkleIcon: React.FC<SVGProps<SVGSVGElement>> = props => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.81818 0L9.13091 1.5L7.63636 2.18182L9.13091 2.86909L9.81818 4.36364L10.5 2.86909L12 2.18182L10.5 1.5M4.36364 1.63636L3 4.63636L0 6L3 7.36364L4.36364 10.3636L5.72727 7.36364L8.72727 6L5.72727 4.63636M9.81818 7.63636L9.13091 9.13091L7.63636 9.81818L9.13091 10.5L9.81818 12L10.5 10.5L12 9.81818L10.5 9.13091"
      fill="currentColor"
    />
  </svg>
);

export default SparkleIcon;
